var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1006.13 180",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{font-size:94.95px;font-family:ArialRoundedMTBold, Arial Rounded MT Bold,'Varela Round', sans-serif;}.cls-1,.cls-5{fill:#fff;}.cls-2{letter-spacing:-0.02em;}.cls-3{letter-spacing:0em;}.cls-4{fill:#4917ff;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Asset 7") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("text", {
    className: "cls-1",
    transform: "translate(185.87 124.55)"
  }, "Account Switcher"), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    width: 180,
    height: 180,
    rx: 35
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M131.32,58A18.7,18.7,0,0,1,150,76.7a18.68,18.68,0,0,1-37.36,0A18.7,18.7,0,0,1,131.32,58m0-4A22.64,22.64,0,1,0,154,76.7a22.64,22.64,0,0,0-22.64-22.64Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M166.58,123.71a2,2,0,0,1-2-1.83A33.43,33.43,0,0,0,152.86,99a29.4,29.4,0,0,1-43.08,0A33.38,33.38,0,0,0,98,121.8a2,2,0,0,1-2.14,1.82,2,2,0,0,1-1.81-2.13A37.37,37.37,0,0,1,108.83,94.7l1.52-1.15L111.56,95a25.47,25.47,0,0,0,39.52,0l1.21-1.48,1.52,1.15a37.38,37.38,0,0,1,14.75,26.88,2,2,0,0,1-1.82,2.13Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M48.11,54.06A22.64,22.64,0,1,0,70.75,76.7,22.64,22.64,0,0,0,48.11,54.06Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M69.41,96.28a27.43,27.43,0,0,1-42.59,0,35.29,35.29,0,0,0-14,25.36,238.91,238.91,0,0,0,35.54,2.61,240.18,240.18,0,0,0,35-2.52A35.37,35.37,0,0,0,69.41,96.28Z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b2f645ed6bb7bda4f0401cd47600d521.svg";
export { ForwardRef as ReactComponent };